import { Arr, Num, Obj } from "@kizmann/pico-js";
import NTableCellString from "@kizmann/nano-ui/src/table/src/table-cell/types/table-cell-string.jsx";

export default Obj.assign({}, NTableCellString, {

    name: 'NTableCellChannel',

    render()
    {
        if ( ! this.init ) {
            return null;
        }

        let tagProps = {
            size: 'xs', type: 'neutral',
        };

        if ( this.input === 'iframe' ) {
            tagProps.type = 'info';
        }

        if ( this.input === 'clickup' ) {
            tagProps.type = 'secondary';
        }

        return (
            <div>
                <NTagsItem {...tagProps}>{this.input}</NTagsItem>
            </div>
        );
    }

});